var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { width: "40.035", height: "40", viewBox: "0 0 40.035 40" } },
    [
      _c("path", {
        attrs: {
          d:
            "M51.345,16.821,36.82,31.334,51.345,45.859,45.864,51.34,31.351,36.815,16.826,51.34,11.31,45.859,25.859,31.334,11.345,16.821l5.481-5.481L31.351,25.818,45.864,11.34Z",
          transform: "translate(-11.31 -11.34)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }